<template>
  <div class="appletSetting">
    <img src="../../assets/images/index/menuNav.png" width="100%" height="auto" />
  </div>
</template>

<script>
export default {
  name: "menuNav",//菜单导航
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/commonLayout.scss';
.appletSetting {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
